import React, { useEffect, useState } from "react";
import SegmentListContainer from "../list/SegmentListContainer";

import { useDispatch, useSelector } from "react-redux";
import Utility, { removeDelayedLoader, showDelayedLoader } from "../../utility/Utility";
import { deepClone } from "../../utility/Utility"
import { DKLabel, DKButton, showAlert, showToast, TOAST_TYPE, DKIcons, Toggle } from "deskera-ui-library";
import DataGridHolderPayroll from "../common/DataGridHolderPayroll";
import { parseColumnConfig, ComponentColumnConfig, parseVisibleColumnConfig, getUsersNames } from "../configs/config";
import { fetchComponent, selectComponent, selectComponentColumnConfig } from "../../Redux/Slices/ComponentListSlice";
import ComponentListService from "../../services/ComponentListService";
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import { TableManger, TABLES, TABLE_DISPLAY_NAME } from "../../managers/TableManger";
import { ComponentManager } from "../../managers/ComponentManager";
import ComponentAddPopup from "./ComponentAddPopup";
import ViewToggle from "../common/ViewToggle";
import ic_list from "../../assets/icons/white/ic_list_bulleted.svg";
import ic_phone_card from "../../assets/icons/white/ic_contact_phone.svg";
import ic_list_white from "../../assets/icons/white/ic_list_bulleted_white.svg";
import ic_phone_card_white from "../../assets/icons/white/ic_contact_phone_white.svg";
import ProfileSetupService from "../../services/ProfileSetup-service";
import { PROFILE_STAGES_CONSTANT } from "../../constants/Constant";
import TenantManager from "../../managers/TenantManager";
import ReadWatchComponent from "../common/ReadWatchComponent";
import AppManager from "../../managers/AppManager";
import { useTranslation } from "react-i18next";
import UserService from "../../services/UserService";
import { fetchEmployeeListWithoutFilter, selectEmployeeListWithoutLimit } from "../../Redux/Slices/EmployeeListSlice";
import EmployeeListService from "../../services/EmployeeListService";
import PermissionUtils, { ACTION, MODULE } from "../user-permissions/PermissionUtils";
const ComponentList = (props) => {
    const { t, i18n } = useTranslation();

    const initialState = {
        columnData: [],
        rowData: [],
        originalData: [],
        filter: []
    };
    //State hooks
    const [refresh, setRefresh] = useState(false);
    const [component, setComponent] = useState(initialState);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPageCount, setTotalPageCount] = useState(0);
    const [totalCount, setTotalCount] = useState(10);
    const [view, setView] = useState(0);
    const [toggle, setToggle] = useState(true);
    const [popup, setPopup] = useState(false);
    const [selectedComponent, setSelectedComponent] = useState(null);
    const [reload, setReload] = useState(false);
    
    
    //Store data selectors
    const dispatch = useDispatch();
    const componentData = useSelector(selectComponent);
    const columnConfig = useSelector(selectComponentColumnConfig);
    const isActionEnabled = true;
    const employeeList = useSelector(selectEmployeeListWithoutLimit);
    const [employeeListState, setEmployeeList] = useState(employeeList)
    useEffect(() => {
        RouteManager.setPresenter({ props });
        /* API Calls Start */
        loadComponent({});
        /* API Calls End */
        return () => setComponent(initialState);
    }, [props.isUpdate])

    useEffect(() => {
        if (!Utility.isEmpty(componentData)) {
            const { components, filterResponse } = componentData;
            const rowData = ComponentColumnConfig(components);
            let componentColumn = parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_COMPONENT))
            componentColumn = parseVisibleColumnConfig(componentColumn)
            const passingData = {
                columnData: deepClone(componentColumn),
                rowData,
                filter: [],
                originalData: rowData
            };

            if (passingData.columnData?.length > 0) {
                passingData.columnData.forEach((c) => {
                    if (c.columnCode === "name") {
                        c.name = t("COMPONENT")
                    }
                });
            }

            setComponent(passingData);
            setTotalPageCount(parseInt(filterResponse.totalPages));
            setCurrentPage(parseInt(filterResponse.currentPage));
            setTotalCount(parseInt(filterResponse.count))
            if (components && components.length != 0) {
                ProfileSetupService.updateStateOfProfileStage(PROFILE_STAGES_CONSTANT.COMPONENT)
                .then(res => {
                        TenantManager.setProfileData(res['profileStages']);
                })
            }

        }
    }, [componentData,view, reload]);

    useEffect(()=>{
        if(!Utility.isEmpty(employeeList)) {
            setEmployeeList(employeeList)
        }
    },[employeeList])

    const loadComponent = async (config) => {
        try {
            const timeout = showDelayedLoader();
            ComponentListService.apiConfig = config;
            await dispatch(fetchComponent());
            removeDelayedLoader(timeout);
            if(Utility.isEmpty(employeeList)) {
                loadEmployee({
                    customJson:{
                        "orderBy.field": "updatedAt",
                        "orderBy.order": "desc",
                      }
                });
            }
        } catch (err) {
            console.error('Error loading contacts: ', err);
        }
    };

    const loadEmployee = async (config) => {
        try {
            EmployeeListService.apiConfig = config;
            await dispatch(fetchEmployeeListWithoutFilter());
        } catch (err) {
            console.error('Error loading employees: ', err);
        }
    };

    const onDeleteComponent = (data) => {
        if( !(data.length > 0)) {
            let componentData = data.rowData;
            if (componentData.component.defaultComponent) {
                showAlert("Info", t("DEFAULT_CANNOT_DELETE"), cannotDeleteOrUpdate)
            } else {
                onDelete([componentData])
            }
        } else if(data.length > 0) {
            let isDefault = false;
            data.forEach(comp=>{
                if(comp.component.defaultComponent){
                    isDefault = true;
                    return;
                }
            })
            if(isDefault) {
                showAlert("Info", t("DEFAULT_CANNOT_DELETE"), cannotDeleteOrUpdate)
            } else {
                onDelete(data)
            }
        }

    };

    const onRowEdit = (data) => {
        if(data.rowData) {
            setSelectedComponent(data.rowData.component)
        } else if(data.length == 1) {
            setSelectedComponent(data[0].component)
        }
        setPopup(true)
    };
    const onSearch = (searchTerm) => {
        const config = {
            ...ComponentListService.apiConfig,
            Page: 0,
            SearchTerm: searchTerm
        };
        loadComponent(config);
    };
    const newColumnAdded = (data) => {
        const columns = component.columnData;
        columns.push(data);
        setComponent({ ...component, columnData: columns });
    };

    const onFilter = (updatedList, queries) => {

    };

    const onRowAdd = (newRow) => {

    };


    const initialComponentFilters = [
        { id: 0, name: t('ALL_COMPONENTS') },
        { id: 1, name: 'Deductions' },
        { id: 2, name: 'Earnings' }
    ]

    const [componentFilters, setComponentFilters] = useState(initialComponentFilters);
    const [initialValue, setFilterInitialValue] = useState(0);

    const cannotDeleteOrUpdate = [
        {
            title: "Cancel",
            className: "bg-gray1 border-m",
        }
    ];

    const onSegmentSelect = (segment, index) => {
        setFilterInitialValue(segment.id);
        let componentsList = componentData.components || [];
        if (segment.id === 1) {
            let filteredData = componentsList.filter(x => (x.type != 'EARNING'));
            component.rowData = ComponentColumnConfig(filteredData)
        } else if (segment.id === 2) {
            let filteredData = componentsList.filter(x => (x.type != 'DEDUCTION'));
            component.rowData = ComponentColumnConfig(filteredData);
        } else {
            component.rowData = ComponentColumnConfig(componentsList);
        }
        setComponent(component);

    };

    const isDefaultComponent = (ele) => {
        if (ele.component.defaultComponent) {
            return true;
        } else {
            return false;
        }
    }
    const isINDefaultComponent = (ele) => {
        const IN_COMP = ['Transport Allowance', 'Commission', 'Bonus'];
        let index = IN_COMP.indexOf(ele.component.name)
        if (ele.component.defaultComponent && index != -1) {
            return true;
        } else {
            return false;
        }
    }
    const changeToggle = (ele) => {
        if (!isDefaultComponent(ele) || isINDefaultComponent(ele)) {
            ele.isActive[0] = (ele.isActive[0] && ele.isActive[0] == 'true') ? 'false' : 'true';
            setToggle(!toggle);
            ComponentManager.updateStatus(ele).then(res => {
                const config = {
                    ...ComponentListService.apiConfig
                };
                loadComponent(config);
                showToast(
                    `Status updated successfully`,
                    TOAST_TYPE.SUCCESS
                );
            }, error => {
                showToast(
                    `Fail to update status`,
                    TOAST_TYPE.FAILURE
                );
            })
        } else {
            showAlert("Info", "Default Component cannot be change status.", cannotDeleteOrUpdate)
            const config = {
                ...ComponentListService.apiConfig
            };
            loadComponent(config);
        }
    }
    const onStatusChange = (data) => {
        changeToggle(data['rowData'])
    }
    const onRowUpdate = (data) => {
        let rowData = (data['rowData']);
        let isActive = (rowData.component.isActive ||( rowData.component.isActive == false))? rowData.component.isActive.toString():'false';
        let selected = rowData.isActive.length!=0 ? rowData.isActive[0]:'';
        if(rowData.component && ( isActive != selected)) {
            changeToggle(data['rowData'])
        } else if(rowData.isActive.length == 0) {
            changeToggle(data['rowData'])
        }
    }
    const onEdit = (ele) => {
        setSelectedComponent(ele.component)
        setPopup(true)
    }
    const onDelete = (ele) => {
        const deleteOrUpdate = [
            {
                title: "No",
                className: "bg-gray1 border-m"
            },
            {
                title: "Yes",
                className: "bg-app text-white ml-s ",
                onClick: () => deleteComponent(ele),
            }

        ];
        showAlert("Info", "Are you sure you want to delete this record? This action cannot be undone later.", deleteOrUpdate)

    }
    const deleteComponent = (ele) => {
        ComponentManager.deleteComponent(ele)
            .then(res => {
                const config = {
                    ...ComponentListService.apiConfig
                };
                loadComponent(config);
                showToast(
                    `Component deleted successfully`,
                    TOAST_TYPE.SUCCESS
                );
            }, error => {
                showToast(
                    `Fail to delete component`,
                    TOAST_TYPE.FAILURE
                );
            })
    }
    const onClose = (res) => {
        setSelectedComponent(null)
        setPopup(false);
        const config = {
            ...ComponentListService.apiConfig
        };
        loadComponent(config);
    }
    const data = [
        { id: 0, name: "List", icon: ic_list_white, unselectedIcon: ic_list },
        { id: 1, name: "Card", icon: ic_phone_card_white, unselectedIcon: ic_phone_card },
    ];
    const onViewChange = (data, index) => {
        setView(data.id);
        setFilterInitialValue(0);
    }
    var cards = component.rowData.map(ele => {
        return (
            <div style={{ position: "relative" }} className="bg-white possition-relative p-xl  pb-l border-radius-m border-box dashboard-card column parent-width border-m">
                <div className="text-align-left parent-width" >
                    <div className="parent-width justify-content-between d-flex">
                        <div className="pt-xs">
                            {(ele.status[0] == "EARNING") && <span className="fs-m border-radius-s data-grid-badge-color-6 p-xs">Earing</span>}
                            {(ele.status[0] == "DEDUCTION") && <span className="fs-m border-radius-s data-grid-badge-color-4 p-xs">Deduction</span>}
                        </div>

                        <div className="d-flex">
                            <DKButton
                                icon={DKIcons.ic_edit}
                                title=""
                                className=""
                                onClick={() => onEdit(ele)}
                            />
                            {!ele.component.defaultComponent &&
                                <DKButton
                                    icon={DKIcons.ic_delete}
                                    title=""
                                    className=""
                                    onClick={() => onDelete([ele])}
                                />}
                        </div>
                    </div>
                    {/* <DKStatus title="Pending" color="bg-red"/> */}
                    <h2 className="mt-s" style={{ marginBottom: 45 }}>{ele.name}</h2>
                    <div className="row">
                        <Toggle className="border-n" isOn={(ele.isActive[0] == 'true') ? true : false} onChange={() => changeToggle(ele)} /> <DKLabel className="ml-l" text={(ele.isActive[0] == 'true') ? "Active" : "Inactive"} />
                    </div>
                    {/* <p className="mt-xl d-flex align-items-center" style={{bottom:8,position:"absolute"}} ><img className="mr-s mb-xs" src={check}/> </p> */}
                </div>
            </div>
        )
    })

    const onContextCancel = () => {
      setReload(!reload)
    }

    return (
        <>
            <div className="row mb-l justify-content-between">
                <div className="parent-width">
                    <ReadWatchComponent
                        title={t("NEED_HELP_COMPONENT")}
                        onRead = { () => window.open(
                            "https://www.deskera.com/care/view-edit-delete-components-deskera-hris/",
                            "_blank"
                        )}
                        onWatch={AppManager.showComingSoonWarning}
                    />
                </div>
                {PermissionUtils.hasAccess(MODULE.EARNINGS_AND_DEDUCTIONS,[ACTION.IMPORT]) && <div className="parent-width ml-l">
                    <div className="bg-deskera-secondary p-r border-radius-m border-m">
                        <DKLabel text={`<span style="font-size:20px">💼</span> Manage your ${t("COMPONENT")}.`} />
                        <div className="row mt-r ml-l">
                            <DKButton
                                title={t("IMPORT_COMPONENT")}
                                icon={DKIcons.ic_import}
                                className="border-m bg-white"
                                onClick={() => {
                                    RouteManager.navigateToPage(PAGE_ROUTES.IMPORT_COMPONENT_VALUES, `module=${TABLES.PEOPLE_COMPONENT}&origin=${PAGE_ROUTES.COMPONENT}`)
                                }}
                            />
                        </div>
                    </div>
                </div>}
            </div>
            <div className="parent-width " style={{
                height: "90%"
            }}>
                <SegmentListContainer
                    data={componentFilters}
                    selectedId={initialValue}
                    onChange={onSegmentSelect}
                    className="d-flex justify-content-end"
                    // onClickNew={this.showAddSegmentPopup}
                    maxWidth={React.createRef().current?.innerWidth}
                    isAddEnabled={false}
                />
                {/* hide for now */}
                {false && <ViewToggle
                    data={data}
                    selectedView={0}
                    onViewChange={onViewChange}
                /> }
                {/* <DKButton title="Change View" style={{display: "table"}} className="bg-app text-white row-reverse" onClick={changeView}/> */}
                <div className="row " style={{
                    height: "100%"
                }}>
                    <div className="column parent-width flex-1 parent-height">
                        <div className="column parent-width mb-s position-relative flex-1 ">

                            {view == 0 && <DataGridHolderPayroll
                                tableName={TABLES.PEOPLE_COMPONENT}
                                displayTableName={t("COMPONENT")}
                                allowColumnEdit={false}
                                allowColumnDelete={false}
                                allowColumnShift={false}
                                allowSearch={false}
                                allowFilter={false}
                                onRowDelete={onDeleteComponent}
                                onRowEdit={(data) => {
                                    onRowEdit(data);
                                }}
                                refresh={refresh}
                                allowRowAdd={true}
                                addButtonConfig={[{
                                    title: String().concat("+ ", t("ADD_COMPONENT")),
                                    // icon:funnel,
                                    className: 'bg-app text-white',
                                    onClick: () => {
                                        setPopup(true)
                                    }
                                }]}
                                allowRowEdit={PermissionUtils.hasAccess(MODULE.EARNINGS_AND_DEDUCTIONS,[ACTION.EDIT])}
                                allowDataExport={false}
                                gridData={component}
                                onSearch={onSearch}
                                onColumnAdd={newColumnAdded}
                                onFilter={onFilter}
                                filter={component.filter}
                                onRowAdd={onRowAdd}
                                onCancelContext={() => {
                                  onContextCancel();
                                }}
                                onPaginationClick={(requestedPageNumber) => {
                                    const config = {
                                        ...ComponentListService.apiConfig,
                                        currentPage: requestedPageNumber
                                    };
                                    loadComponent(config);
                                }}
                                currentPage={currentPage}
                                totalPageCount={totalPageCount}
                                isActionEnabled={isActionEnabled}
                                contextMenu={true}
                                onStatusChange={onStatusChange}
                                isMenuVisible={true}
                                onRowUpdate={onRowUpdate}
                                onColumnShift={(data)=> setReload(!reload)}
                                module={MODULE.EARNINGS_AND_DEDUCTIONS}
                            />}
                            {view == 1 &&
                                <div className="parent-width pt-s">
                                    <div className="row justify-content-between">
                                        <DKLabel className=" fs-r text-align-left fw-m fs-l" text="Component" />
                                        <DKButton title="+ Add Component" className='bg-app text-white' onClick={() => {

                                            setPopup(true)
                                        }} />
                                    </div>
                                    <div className="row flex-wrap justify-content-between align-items-stretch dashboard-card-wrapper pb-xxl">
                                        {cards}
                                    </div>
                                </div>
                            }
                        </div>

                    </div>
                </div>

            </div>
            {popup && <ComponentAddPopup selectedComponent={selectedComponent} employeeList={employeeListState} onClose={(res) => { onClose(res) }} />}
        </>
    )
}

export default ComponentList;
